/* unplugin-vue-components disabled */import { render } from "./new-chat-v2.vue?vue&type=template&id=619ec3be&scoped=true"
import script from "./new-chat-v2.vue?vue&type=script&lang=js"
export * from "./new-chat-v2.vue?vue&type=script&lang=js"

import "./new-chat-v2.vue?vue&type=style&index=0&id=619ec3be&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619ec3be"],['__file',"src/pages/new-chat/new-chat-v2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "619ec3be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('619ec3be', __exports__)) {
    api.reload('619ec3be', __exports__)
  }
  
  module.hot.accept("./new-chat-v2.vue?vue&type=template&id=619ec3be&scoped=true", () => {
    api.rerender('619ec3be', render)
  })

}


export default __exports__